/**
 * 商品の表示パーツ
 */
import UnicoUtils from './script-utils.js';

export default class ProductItem extends HTMLElement {
  constructor() {
    super();

    // 各種要素を取得
    this.colorList = this.querySelectorAll('.unico-item-color-list-item');
    this.thumbList = this.querySelectorAll('.unico-item-thumb-list-item');
    this.legList = this.querySelectorAll('.unico-item-leg-list-item');
    this.favoriteButton = this.querySelector('unico-favorite-button');

    // 初期化処理
    this.initColorVariation();
    this.initLegVariation();

    if (this.favoriteButton) {
      // 位置調整するまではお気に入りボタンを非表示
      this.favoriteButton.style.visibility = 'hidden';
      // お気に入りボタンの位置調整
      window.addEventListener('DOMContentLoaded', () =>
        this.initFavoriteButton(),
      );
      window.addEventListener('resize', () => this.initFavoriteButton());
    }
  }

  connectedCallback() {
    if (this.favoriteButton) {
      this.observeVisibility();
    }
  }

  /**
   * お気に入りボタンが表示されたタイミングで位置調整を実行
   */
  observeVisibility() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initFavoriteButton();
        }
      });
    });
    observer.observe(this.favoriteButton);
  }

  /**
   * カラーバリエーションの切り替え処理の初期化
   */
  initColorVariation() {
    // ホバーでメイン画像を差し替える
    this.colorList.forEach((colorItem, index) => {
      // ホバー時のサムネイル切り替え処理
      colorItem.addEventListener('mouseover', (event) => {
        this.thumbList.forEach((item) => {
          item.classList.remove('-is-active');
        });
        if (this.thumbList[index]) {
          this.thumbList[index]?.classList.add('-is-active');
        }
      });

      // マウスアウト時のサムネイル切り替え処理
      colorItem.addEventListener('mouseout', (event) => {
        let activeIndex = -1;
        this.colorList.forEach(function (item, index) {
          if (item.classList.contains('-is-active')) {
            activeIndex = index;
          }
        });
        this.thumbList.forEach((item) => {
          item.classList.remove('-is-active');
        });
        if (this.thumbList[activeIndex]) {
          this.thumbList[activeIndex].classList.add('-is-active');
        }
      });

      // クリック時のサムネイル・カラーチップ切り替え処理
      colorItem.addEventListener('click', (event) => {
        this.colorList.forEach((item) => {
          item.classList.remove('-is-active');
        });
        this.colorList[index].classList.add('-is-active');
        this.urlChanger(this.colorList[index])
        this.thumbList.forEach((item) => {
          item.classList.remove('-is-active');
        });
        this.thumbList[index]?.classList.add('-is-active');
      });
    });
  }

  /**
   * 脚バリエーションの切り替え処理の初期化
   */
  initLegVariation() {
    // ホバーでメイン画像を差し替える
    this.legList.forEach((legItem, index) => {
      // 一つ目をアクティブ表示に
      if (index === 0) legItem.classList.add('-is-active');

      // クリック時のアクティブ切り替え処理
      legItem.addEventListener('click', (event) => {
        this.legList.forEach(item => {
          item.classList.remove('-is-active');
        });
        this.legList[index].classList.add('-is-active');
      });
    });
  }
  
  urlChanger(e) {
    const url = e.getAttribute('data-variant');
    const targets = e.closest('unico-product-item').querySelectorAll('a');
    targets.forEach((target) => {
      target.setAttribute('href', url);
    });
  }
  /**
   * お気に入りボタンの初期化
   */
  initFavoriteButton() {
    const target = this.querySelector('.unico-item-price');
    const targetPosition = UnicoUtils.getRelativePosition(target, this);
    this.favoriteButton.style.visibility = 'visible';
    this.favoriteButton.style.top = `${targetPosition.top}px`;
  }
}
